import produce from 'immer';
import { LOAD_INTEGRATION_WITH_METHODS_REQUEST, LOAD_INTEGRATION_WITH_METHODS_SUCCESS, LOAD_INTEGRATION_WITH_METHODS_FAILURE, } from './constants';
export var initialState = {
    integration: {},
    loading: false,
    error: false,
    methods: [],
    methods_loading: false,
    methods_error: false,
};
function integrationReducer(currentState, action) {
    if (currentState === void 0) { currentState = initialState; }
    return produce(currentState, function (state) {
        switch (action.type) {
            case LOAD_INTEGRATION_WITH_METHODS_REQUEST:
                state.loading = true;
                state.error = false;
                break;
            case LOAD_INTEGRATION_WITH_METHODS_SUCCESS:
                state.loading = false;
                state.error = false;
                state.integration = action.integration.object;
                state.methods = action.methods.objects;
                break;
            case LOAD_INTEGRATION_WITH_METHODS_FAILURE:
                state.loading = false;
                state.error = false;
                break;
            default:
        }
    });
}
export default integrationReducer;
